// This file is generated by a script. Do not edit this file directly.
var _excluded = ["children", "className", "leading", "size", "variant", "tag", "weight"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import React from 'react';
import { cn } from "../../common/utils";
var VARIANT_CLASSNAMES = {
  body: 'cop-font-sans',
  display: 'cop-font-sans',
  heading: 'cop-font-sans'
};
var SIZE_CLASSNAMES = {
  xs: 'cop-text-xs',
  sm: 'cop-text-sm',
  base: 'cop-text-base',
  lg: 'cop-text-lg',
  xl: 'cop-text-xl',
  '2xl': 'cop-text-2xl',
  '3xl': 'cop-text-3xl',
  '4xl': 'cop-text-4xl',
  '5xl': 'cop-text-5xl',
  '6xl': 'cop-text-6xl'
};
var LEADING_CLASSNAMES = {
  tight: 'cop-leading-tight',
  snug: 'cop-leading-snug',
  normal: 'cop-leading-normal',
  relaxed: 'cop-leading-relaxed',
  loose: 'cop-leading-loose',
  '8': 'cop-leading-8',
  '7': 'cop-leading-7',
  '6': 'cop-leading-6',
  '5': 'cop-leading-5',
  '4': 'cop-leading-4',
  '3': 'cop-leading-3',
  '2': 'cop-leading-2',
  '1': 'cop-leading-1',
  '075': 'cop-leading-075',
  '050': 'cop-leading-050',
  '025': 'cop-leading-020'
};
var WEIGHT_CLASSNAMES = {
  bold: 'cop-font-bold',
  semibold: 'cop-font-semibold',
  medium: 'cop-font-medium',
  regular: 'cop-font-regular',
  light: 'cop-font-light'
};
export var Base = function Base(_ref) {
  var children = _ref.children,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    leading = _ref.leading,
    size = _ref.size,
    variant = _ref.variant,
    tag = _ref.tag,
    weight = _ref.weight,
    props = _objectWithoutProperties(_ref, _excluded);
  var Tag = tag;
  return /*#__PURE__*/React.createElement(Tag, _extends({
    className: cn('cop-m-0', VARIANT_CLASSNAMES[variant], SIZE_CLASSNAMES[size], LEADING_CLASSNAMES[leading], WEIGHT_CLASSNAMES[weight], className)
  }, props), children);
};
